import { ReactNode, useEffect, useState } from "react";

import { Box, ButtonProps } from "@vinomofo/components";
import useOneSignal from "../../hooks/use-onesignal";
import useAuth from "../../hooks/use-auth";
import { NotificationBanner } from "../notification-banner";

export interface PushNotificationBannerProps extends ButtonProps {
  title: string;
  message: ReactNode;
}

export const PushNotificationBanner = ({
  color = "white",
  title,
  message,
}: PushNotificationBannerProps): JSX.Element => {
  const {
    initialized,
    permission,
    subscribed,
    handleSubscribe,
  } = useOneSignal();
  const { user, isLoading } = useAuth();
  const [externalUserId, setExternalUserId] = useState(null);

  const getExternalUserID = (user) => {
    if (user) {
      return (
        user["https://www.vinomofo.com/app_metadata"] &&
        user["https://www.vinomofo.com/app_metadata"][
          `${process.env.GATSBY_VM_MARKET}_EXTERNAL_ID`
        ]
      );
    }
  };

  useEffect(() => {
    if (!isLoading) {
      setExternalUserId("" + getExternalUserID(user));
    }
  }, [isLoading]);

  const BlockedMessage = () => {
    return (
      <>
        Push notifications are disabled by your browser. Change your browser
        settings to allow them.
      </>
    );
  };
  return initialized ? (
    <>
      {permission === "denied" ? (
        <NotificationBanner
          title={title}
          message={BlockedMessage()}
          onClick={() => handleSubscribe(externalUserId)}
          backgroundColor="charlie"
          borderRadius="5px"
          width="100%"
          hoverColor={color}
        />
      ) : (
        permission !== "granted" && (
          <NotificationBanner
            title={title}
            message={message}
            onClick={() => handleSubscribe(externalUserId)}
            backgroundColor="papaSmurf"
            borderRadius="5px"
            width="100%"
            hoverColor={color}
          />
        )
      )}
      {permission === "granted" && subscribed && null}
    </>
  ) : null;
};
